// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cz-b";
export var colorBlue = "_cz-8";
export var colorDot = "_cz-0";
export var colorDotLarge = "_cz-2";
export var colorDotSmall = "_cz-1";
export var colorGreen = "_cz-7";
export var colorGrey = "_cz-3";
export var colorOrange = "_cz-5";
export var colorPink = "_cz-a";
export var colorPurple = "_cz-9";
export var colorRed = "_cz-4";
export var colorYellow = "_cz-6";